export default "__VITE_ASSET__CDG_JI3y__"